import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as actions from '../actions'
import ReportePorSectorView from '../components/ReportePorSectorView'

class ReportePorSector extends Component {
  componentDidMount () {
    this.props.fetchSectores()
  }

  render () {
    return <ReportePorSectorView />
  }
}

const withRedux = connect(null, actions)

export default withRedux(ReportePorSector)
